export const logError = (err: unknown, customAttributes?: Record<string, string | number | null | undefined>) => {
  console.error(err);

  if (process.env.ENABLE_DT_LOGGING) {
    window.newrelic?.noticeError?.(err, customAttributes);
  }
};
window.logError = logError;
